import { render } from "./LoadingLoad.vue?vue&type=template&id=626ec10a"
import script from "./LoadingLoad.vue?vue&type=script&lang=js"
export * from "./LoadingLoad.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__